<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const props = defineProps({
    id: {
        type: Number,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const usage = ref(undefined);

// --- Computed ---

const sectionName = computed(() => store.state.themes.sectionName);

// --- Logic (Created equivalent) ---

// Only display and fetch data on the Content Types tab.
if (sectionName.value === 'content_types') {
    store.dispatch('themes/getItemsUsage')
        .then((obj) => {
            usage.value = obj[props.id] || 0;
        });
}

// --- Methods ---

const showPanel = () => {
    store.dispatch('modals/show', {
        componentName: 'ThemesUsageModal',
        obj: {
            id: props.id
        }
    });
};
</script>

<template>
    <Button
        v-if="usage !== undefined"
        class="btn-sm p-0 px-1"
        @click.prevent.stop.native="showPanel"
    >
        <small>{{ usage }}</small>
    </Button>
</template>